import { RadioGroupItemType } from './types';
import { ReactNode } from 'react';
import { BorderColor, Box, FlexBox } from '@ardoq/layout';
import { colors } from '@ardoq/design-tokens';

type StateProps = {
  isChecked?: boolean;
  isDisabled?: boolean;
};

export type RadioGroupItemTypeWrapperProps = {
  media?: ReactNode;
  children?: ReactNode;
  groupItemType?: RadioGroupItemType;
} & StateProps;

const getBorderColor = (props: StateProps): BorderColor => {
  if (props.isDisabled) return 'borderDisabled';
  if (props.isChecked) return 'borderFocus';
  return 'borderAction';
};

export const RadioGroupItemTypeWrapper = ({
  children,
  media,
  isChecked = false,
  isDisabled = false,
  groupItemType = RadioGroupItemType.DEFAULT,
}: RadioGroupItemTypeWrapperProps) => {
  const borderColor = getBorderColor({ isChecked, isDisabled });

  switch (groupItemType) {
    case RadioGroupItemType.CARD:
      return (
        <Box
          padding="medium"
          borderColor={borderColor}
          borderWidth={1}
          borderRadius="r8"
          backgroundColor="surfaceDefault"
        >
          {children}
        </Box>
      );
    case RadioGroupItemType.CARD_MEDIA:
      return (
        <Box
          borderRadius="r8"
          backgroundColor="surfaceDefault"
          style={{
            overflow: 'hidden',
            // hack to avoid an `inset` box shadow which would be covered by `width: '100%';` media
            boxShadow: `0 0 0 1px ${colors[borderColor]}`,
          }}
        >
          <FlexBox
            justify="center"
            align="center"
            width="full"
            style={{
              // hack to mirror the shadow of the parent between the media and children,
              // but we don't want a focused border here
              boxShadow: `0 0 0 1px ${colors[borderColor === 'borderFocus' ? 'borderAction' : borderColor]}`,
              opacity: isDisabled ? '33%' : undefined,
            }}
          >
            {media}
          </FlexBox>
          <Box padding="medium">{children}</Box>
        </Box>
      );
    default:
      return <div>{children}</div>;
  }
};
